// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__VH5pY","wrapper-nopadding":"wrapper-nopadding__1U1KX","loading":"loading__2nll6","error":"error__2S8Bg","table-loading":"table-loading__xIhYy","empty-val":"empty-val__1ECKw","panelheader-tools":"panelheader-tools__2jpsd","propsPanels":"propsPanels__3T08x","new":"new__1zDeb","marginLm":"marginLm__hYB35","marginRm":"marginRm__1hc92","fullWidth":"fullWidth__1ax0s","fullHeight":"fullHeight__1QF6T","noData":"noData__2feGs"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/base.scss
// module id = 832
// module chunks = 1